import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import SimpleBarFilterCustom from '../../../components/Common/SimpleBarFilterCustom'
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from 'reactstrap'
import ProgressBar from '../../../components/Common/ProgressBar'
import {
  fnGetValueByKey
} from '../../../helpers/functions'
import InputSearch from '../../../components/Inputs/InputSearch'

import CardContextDynamic from '../../../components/Common/CardContextDynamic'
import { Skeleton } from 'primereact/skeleton'
import HeaderDefaultToPage from '../../../components/Common/headerDefaultToPage'
import CardFlowDynamic from '../../../components/Common/CardFlowDynamic'
import PreFilterBadge from '../../../components/Common/PreFilterBadge'
import { exportGridToExcel, exportGridToCSV, exportGridToHTML, exportDashboardToHTML } from '../../../components/Utils/export'
import ButtonTransactionFavorite from '../../../components/Dynamic/ButtonTransactionFavorite'
import TranspaleStringToComponente from '../../../components/Dynamic/TranspaleStringToComponente'
import CardContextExpansiveDynamic from '../../../components/Common/CardContextExpansiveDynamic'
import ElementWithGenericTrigger from '../../../components/Utils/ElementWithGenericTrigger'

export default function GridHeader({ context }) {
  const {
    isLoading,
    gridComponents,
    paramsOnFilter,
    setParamsOnFilter,
    setTriggerOnFilter,
    setIsOpenModal,
    isOpenModal,
    setInputGlobalSearchValue,
    filteredData
  } = React.useContext(context)
  
  const headerComponentsRender = gridComponents.HEADER[0]?.Childrens

  const {isModalPage, isIframePage} = useSelector(state => ({
    isModalPage: state.Layout.isModalPage,
    isIframePage: state.Layout.isIframePage
  }))
  
  const [preFilter, setPreFilter] = useState([])
  const [btnActionExport, setBtnActionExport] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [progressMessage, setProgressMessage] = useState('')

  const handleExport = async (item) => {
    try {
      setIsExporting(true)
      setShowProgressBar(true)
      setExportProgress(0)
      
      const icone = item?.icone || ''
      const label = (item?.label || '').toLowerCase()
      const pageTitle = fnGetValueByKey(gridComponents.HEAD[0]?.Childrens, 'TITULO_TRANSACAO') || 'Relatório de Dados'
      const transactionCode = fnGetValueByKey(gridComponents.HEAD[0]?.Childrens, 'CODIGO_TRANSACAO') || 
                              fnGetValueByKey(gridComponents.HEAD[0]?.Childrens, 'Codigo_Transacao')
      
      const options = { 
        title: pageTitle, 
        transactionCode,
        appliedFilters: paramsOnFilter,
        filteredData
      }
    
      setExportProgress(5)
      await new Promise(resolve => setTimeout(resolve, 100))

      if (icone.includes('fa-file-pdf') || label.includes('pdf')) {
        // PDF: usar a mesma lógica que HTML (gerar HTML e enviar para API /gerar-pdf)
        setExportProgress(30)
        setProgressMessage('Gerando PDF...')
        await new Promise(resolve => setTimeout(resolve, 200))
        
        if (!hasGridTable) {
          // Para dashboard, gerar PDF via DOCVIEW usando a API /gerar-pdf
          // A função exportDashboardToHTML internamente chama /gerar-pdf e retorna PDF
          console.log('[GridHeader] Iniciando geração de PDF do dashboard...')
          try {
            await exportDashboardToHTML(gridComponents, { ...options, filename: 'dashboard.pdf' })
            console.log('[GridHeader] PDF gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar PDF:', error)
            setProgressMessage('Erro ao gerar PDF. Verifique o console.')
            throw error
          }
        } else {
          // Para grid, gerar HTML e enviar para API /gerar-pdf
          console.log('[GridHeader] Iniciando geração de PDF do grid...')
          try {
            await exportGridToHTML(gridComponents, { ...options, filename: 'relatorio.pdf' })
            console.log('[GridHeader] PDF gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar PDF:', error)
            setProgressMessage('Erro ao gerar PDF. Verifique o console.')
            throw error
          }
        }
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-excel') || label.includes('excel') || label.includes('xlsx')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToExcel(gridComponents, { ...options, filename: 'relatorio.xlsx' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-csv') || label.includes('csv')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToCSV(gridComponents, { ...options, filename: 'relatorio.csv' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-code') || label.includes('html')) {
        // HTML: sempre retornar HTML (não converter para PDF)
        setExportProgress(30)
        setProgressMessage('Gerando HTML...')
        await new Promise(resolve => setTimeout(resolve, 200))
        
        if (!hasGridTable) {
          // Para dashboard, retornar HTML (não converter para PDF)
          console.log('[GridHeader] Iniciando geração de HTML do dashboard...')
          try {
            await exportDashboardToHTML(gridComponents, { ...options, filename: 'dashboard.html', convertToPdf: false })
            console.log('[GridHeader] HTML gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar HTML:', error)
            setProgressMessage('Erro ao gerar HTML. Verifique o console.')
            throw error
          }
        } else {
          // Para grid, retornar HTML (não converter para PDF)
          console.log('[GridHeader] Iniciando geração de HTML do grid...')
          try {
            await exportGridToHTML(gridComponents, { ...options, filename: 'relatorio.html', convertToPdf: false })
            console.log('[GridHeader] HTML gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar HTML:', error)
            setProgressMessage('Erro ao gerar HTML. Verifique o console.')
            throw error
          }
        }
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
      }

      // Finalização
      setExportProgress(100)
      
    } catch (error) {
      console.error('Erro na exportação:', error)
      // Se houver erro na geração de PDF, mostrar mensagem amigável
      if (error.message && error.message.includes('PDF')) {
        setProgressMessage('Erro ao gerar PDF. Verifique o console para mais detalhes.')
      }
    } finally {
      setIsExporting(false)
      setBtnActionExport(false)
      setShowProgressBar(false)
      setExportProgress(0)
      setProgressMessage('')
    }
  }

  const contextBlock = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'CONTEXTO_001'
  )

  const contextBlock2 = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'CONTEXTO_002'
  )

  const contextBlockExpansive1 = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'CONTEXTO_EXPANSIVEL_001'
  )

  const flowBlock = headerComponentsRender?.find(
    item => item.Chave_Transacao_Componente === 'FLUXO_001'
  )

  const btnExport = fnGetValueByKey(
    headerComponentsRender,
    'BOTAO_EXPORTAR',
    true
  )

  let btnFavoriteProps = fnGetValueByKey( headerComponentsRender, 'BOTAO_FAVORITAR', false, 'Childrens' )
  let btnNovo = fnGetValueByKey( headerComponentsRender, 'BOTAO_NOVO', false, 'Childrens' )

  let exportFormats = fnGetValueByKey(
    headerComponentsRender,
    'BOTAO_EXPORTAR',
    false,
    'Childrens'
  )
  exportFormats =
    JSON?.parse(fnGetValueByKey(exportFormats, 'BOTAO_EXPORTAR_FORMATOS')) || []

  const hasGridTable = !!gridComponents?.BODY?.[0]?.Childrens?.some?.(
    c => c.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_001'
  )

  const onSubmitFilter = data => {
    setIsOpenModal(false)
    console.log("data: ", data);
    setParamsOnFilter([{ ...data[0] }])
    setTriggerOnFilter(true)
  }

  const onClearFilter = () => {
    setParamsOnFilter([])
    setPreFilter([])
    setIsOpenModal(false)
    setTriggerOnFilter(true)
  }

  return (
    <>
      <Row>
        <Col
          lg={12}
          className={`mb-3 nav-accordion-custom ${isLoading ? 'disabled' : ''}`}
        >
          <Row className={`d-flex align-items-center justify-content-between ${!isModalPage ? 'py-3' : ''}`}>
            <Col id={`header-primary-title ${isModalPage ? 'd-none' : ''}`} >             
              <HeaderDefaultToPage
                title={fnGetValueByKey(
                  gridComponents.HEAD[0]?.Childrens,
                  'TITULO_TRANSACAO'
                )}
              />
            </Col>
            <Col
            id="header-secundary-actions"
              lg={6}
              className="d-flex justify-content-end gap-3 align-items-center"
            >
              {btnNovo?.length > 0 && (
                <ElementWithGenericTrigger 
                  elementValue={fnGetValueByKey(btnNovo, 'TITULO')}
                  elementClassName={fnGetValueByKey(btnNovo, 'ESTILO')}
                  fnInString={fnGetValueByKey(btnNovo, 'ACTION')}
                />
              )}
              {fnGetValueByKey(
                headerComponentsRender,
                'BOTAO_ATUALIZAR',
                true
              ) && (
                <Button
                  onClick={() => onSubmitFilter(preFilter)}
                  className="bg-transparent border-0 p-0 m-0"
                > 
                <i className="fa-solid font-size-24 fa-rotate-right text-primary-dark"></i>                  
                </Button>
              )}
              {fnGetValueByKey(
                headerComponentsRender,
                'BOTAO_IMPRIMIR',
                true
              ) && (
                <Button
                  onClick={() => window.print()}
                  className="bg-transparent border-0 p-0 m-0"
                > 
                <i className="fas font-size-24 fa-print text-primary-dark"></i>                  
                </Button>
              )}
              {btnExport && (
                <>
                  <Dropdown
                    isOpen={btnActionExport}
                    toggle={() => setBtnActionExport(!btnActionExport)}
                    className="dropdown-export-dynamic w-auto"
                  >
                    <DropdownToggle
                      className="bg-transparent border-0 p-0 m-0"
                      caret
                      disabled={isExporting}
                    >
                      {isExporting ? (
                        <div className="spinner-border spinner-border-sm text-primary" role="status" />
                      ) : (                                                
                        <i className="fas font-size-24 fa-save text-primary-dark"></i>                        
                      )}
                  </DropdownToggle>
                    <DropdownMenu>
                      {exportFormats?.map((format, index) => (
                        <DropdownItem
                          onClick={() => handleExport(format)}
                          disabled={isExporting}
                          className="d-flex align-items-center gap-3"
                          key={`export-${index}`}
                        >
                          <i className={format.icone || 'fas fa-file'}></i>
                          <span>{format.label || 'Exportar'}</span>
                    </DropdownItem>
                      ))}
                  </DropdownMenu>
                  </Dropdown>
                </>
              )}

              {btnFavoriteProps && <ButtonTransactionFavorite data={btnFavoriteProps} />}
              
              {fnGetValueByKey(headerComponentsRender, 'INPUT_BUSCA', true) && (
                <form onSubmit={() => {}}>
                  <InputSearch
                    placeholder={'Busca rápida'}
                    onChange={e => setInputGlobalSearchValue(e)}
                  />
                </form>
              )}

              {fnGetValueByKey(
                headerComponentsRender,
                'FILTRO_MODAL',
                true
              ) && (
                <>
                  <SimpleBarFilterCustom
                    isOpen={isOpenModal}
                    onClose={setIsOpenModal}
                    onSubmit={() => onSubmitFilter(preFilter)}
                    onClearFilter={onClearFilter}
                  >
                    <Row className="m-0 mb-1 form-custom01-filter">
                      {fnGetValueByKey(
                        headerComponentsRender,
                        'FILTRO_MODAL',
                        false,
                        'Childrens'
                      )?.map((i, _k) => (
                        <div className="m-0 p-0" key={_k}>
                          <TranspaleStringToComponente item={i} preFilter={preFilter} onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} />
                        </div>
                      ))}
                    </Row>
                  </SimpleBarFilterCustom>
                  <Button
                    onClick={() => setIsOpenModal(true)}
                    style={{ height: 40, width: 113 }}
                    className="button-filter-action font-w-600 bg-primary-dark border-0 text-white px-4 btn-hover-primary"
                  >
                    Filtros
                  </Button>
                </>
              )}
            </Col>
            <Col md={12}>
              {paramsOnFilter[0] &&
                Object.keys(paramsOnFilter[0]).length !== 0 && (
                <div className="container-pre-filter-header">
                  <div className="d-flex flex-wrap p-0 gap-2 align-items-center">
                    <button className="btn px-0 border-0 text-black fonto-w-500 font-size-12">
                      Filtros aplicados:
                    </button>
                    {Object.keys(paramsOnFilter[0]).map((key, i) => {
                        if (Array.isArray(paramsOnFilter[0][key])) {
                        return (
                          <>
                              {paramsOnFilter[0][key][0].values.map(
                                (item, _i) => (
                              <PreFilterBadge
                                index={_i}
                                field={paramsOnFilter[0][key][0].field}
                                value={item.label || item.value}
                                callback={index => {
                                  const obj = { ...paramsOnFilter[0] }
                                  const pre = { ...preFilter[0] }

                                  let values = pre[key][0]?.values || []
                                      values = values.filter(
                                        (_, i) => i !== index
                                      )

                                      obj[key] = [
                                        { ...obj[key][0], values: values }
                                      ]
                                      pre[key] = [
                                        { ...pre[key][0], values: values }
                                      ]
                                  
                                  if (values.length === 0) {
                                    delete obj[key]
                                    delete pre[key]
                                  }
                                  
                                  setPreFilter([pre])
                                  onSubmitFilter([obj])
                                }}
                              />
                                )
                              )}
                          </>
                        )                          
                        } else {
                          return (
                            <PreFilterBadge
                          index={i}
                          field={paramsOnFilter[0][key].field}
                              label={
                                paramsOnFilter[0][key]?.isSelect ? '' : key
                              }
                              value={
                                paramsOnFilter[0][key].label ||
                                paramsOnFilter[0][key].value
                              }
                          callback={() => { 
                            const obj = { ...paramsOnFilter[0] }
                            const pre = { ...preFilter[0] }
                            delete obj[key]
                            delete pre[key]
                            setPreFilter([pre])
                            onSubmitFilter([obj])
                          }} 
                          />
                          )
                      }
                    })}                    
                  </div>
                </div>
              )}
            </Col>
          </Row>
          
          {/* Progress Bar para Exportação */}
          <ProgressBar
            progress={exportProgress}
            message={progressMessage || 'Gerando relatório...'}
            isVisible={showProgressBar}
            showPercentage={true}
            autoHide={true}
            className="export-progress-bar"
          />
          
          <Row className="d-flex align-items-center">
            {flowBlock?.Childrens && (
              <div className={`${fnGetValueByKey(flowBlock?.Childrens, "LARGURA_COLUNA", false)} ${isModalPage && 'col-12'} mb-1 mt-1`}>
                <CardFlowDynamic dataTree={flowBlock?.Childrens} />
              </div>
            )}
            {isLoading ? (
              <Col className="flex-grow-1 mb-4">
                <Skeleton width="100%" height="5rem" />
              </Col>
            ) : (
              <>
                {contextBlock && (
                  <div className={`${fnGetValueByKey(contextBlock?.Childrens, "LARGURA_COLUNA", false)} ${isModalPage && 'col-12'} mb-3 mt-3`}>
                    <CardContextDynamic contextBlock={contextBlock?.Childrens} />
                  </div>
                )}
                {contextBlock2 && (
                  <div className={`${fnGetValueByKey(contextBlock2?.Childrens, "LARGURA_COLUNA", false)} ${isModalPage && 'col-12'}`}>
                    <CardContextDynamic contextBlock={contextBlock2?.Childrens} />
                  </div>
                )}
                {contextBlockExpansive1 && (
                  <div className='col-12'>
                    <CardContextExpansiveDynamic contextBlock={contextBlockExpansive1?.Childrens} />
                  </div>
                )}
              </>                
            )}
          </Row>
          
        </Col>
      </Row>
    </>
  )
}